module.exports = __webpack_public_path__ + "static/img/btn_dkjj_left_pre.c3196e9d.png";